

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface QualificationsParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface Qualifications {
    id?: number;
    name: string;
    shortName:string;
    
  parameters?: QualificationsParameter[];
  links?: any;
}

export abstract class QualificationsData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(): Observable<Qualifications[]>;
  abstract create(url: string,data: Qualifications): Observable<any>;
  abstract update(url: string,data: Qualifications): Observable<any>;
  abstract delete(url: string): Observable<any>;
}